import { lazy, Suspense } from 'react'
import { MediaFolder, StorageType } from '@wordpuppi/shared'
import { InsertFormButton } from '@/components/InsertFormButton'

interface PostEditorProps {
  content: string
  onChange: (content: string) => void
  placeholder?: string
  /** Site slug for uploading images. If not provided, falls back to URL prompt. */
  siteSlug?: string
  /** Folder to upload images to. Defaults to 'posts'. */
  folder?: MediaFolder
  /** Storage type for the site (local, s3, supabase). Used for media URL parsing. */
  storageType?: StorageType
}

// Lazy load MDXEditor to prevent it from blocking the app
const MDXEditorWrapper = lazy(() => import('./MDXEditorWrapper'))

export function PostEditor({
  content,
  onChange,
  placeholder = 'Start writing...',
  siteSlug,
  folder = 'posts',
  storageType,
}: PostEditorProps) {
  return (
    <div className="space-y-2">
      {siteSlug && (
        <div className="flex justify-end">
          <InsertFormButton
            siteSlug={siteSlug}
            onInsert={(marker) =>
              onChange(content ? `${content}\n\n${marker}\n` : `${marker}\n`)
            }
            className="inline-flex items-center justify-center h-8 px-2 text-sm rounded-md border text-muted-foreground hover:bg-muted cursor-pointer"
          />
        </div>
      )}
      <Suspense fallback={<div className="p-4 text-muted-foreground">Loading editor...</div>}>
        <MDXEditorWrapper
          content={content}
          onChange={onChange}
          placeholder={placeholder}
          siteSlug={siteSlug}
          folder={folder}
          storageType={storageType}
        />
      </Suspense>
    </div>
  )
}
